export const btnPrimary = 'inline-flex items-center justify-center px-4.5 py-2 sm:px-6 sm:py-3 text-xs sm:text-sm font-semibold text-white bg-black rounded-lg hover:opacity-80 transition-opacity';

// Type scale by role: one size per role across the whole landing.
export const TYPE = {
  display:
    'font-heading text-4xl sm:text-5xl md:text-6xl lg:text-[72px] font-normal tracking-[-0.035em] leading-[1.04]',
  eyebrow: 'text-xs sm:text-[13px] font-semibold uppercase tracking-wider',
  title: 'text-[32px] sm:text-[40px] lg:text-[48px] font-normal tracking-[-0.035em] leading-[1.1] text-balance',
  heading: 'text-2xl sm:text-[28px] lg:text-[32px] font-normal tracking-[-0.03em] leading-[1.15] text-balance',
  body: 'text-base sm:text-[17px] leading-relaxed text-pretty',
  caption: 'text-xs sm:text-[13px]',
} as const;

// Section surfaces: the dark one is shared by the footer and dark landing chapters.
export const SURFACE = {
  dark: 'bg-[#232323] text-white',
  grey: 'bg-[#f4f4f4]',
  white: 'bg-white',
} as const;

// Controls: same height, radius and text size wherever they appear (matches EchoGetStartedButton).
export const UI = {
  btn: 'inline-flex items-center justify-center gap-2 h-10 px-5 rounded-none text-[13px] font-medium transition-colors',
  btnSm: 'inline-flex items-center justify-center gap-2 h-8 px-3.5 rounded-none text-[12px] font-medium transition-colors',
  dark: 'bg-black hover:bg-neutral-800 text-white',
  chip: 'px-3.5 py-1.5 rounded-lg text-xs sm:text-[13px] font-medium transition-colors',
  navLink: 'text-[13px] font-medium text-[#181a1a] hover:opacity-70 transition-opacity',
} as const;

// Landing layout scale: every section reads its rhythm, gutter, width and type from here.
// Vertical steps grow ~1.25× per breakpoint so density drops as the screen grows.
export const LAYOUT = {
  section: 'py-24 sm:py-32 lg:py-40',
  // For sections ending on a footer strip that should sit on the next section's edge.
  sectionTop: 'pt-24 sm:pt-32 lg:pt-40 pb-6 sm:pb-8',
  gutter: 'px-6 sm:px-10 xl:px-16',
  narrow: 'w-full max-w-[1120px] mx-auto',
  wide: 'w-full max-w-[1280px] mx-auto',
  // Full-bleed sections (testimonials, stats, pricing) span the viewport with their own gutter.
  bleed: 'w-full px-4 sm:px-6 md:px-10 lg:px-12 xl:px-16',
  headerGap: 'mb-14 sm:mb-16 lg:mb-20',
  gap: 'mt-14 sm:mt-16 lg:mt-20',
  split: 'gap-14 lg:gap-20',
  // Rounded segment: a run of tinted sections reads as one card set into the white page.
  // overflow-clip (not hidden) so sticky children keep working.
  panel: 'rounded-[20px] sm:rounded-[28px] overflow-clip',
  panelTop: 'rounded-t-[20px] sm:rounded-t-[28px]',
  // Rounded bottom edge laid over the next section, which tucks under by the same radius.
  // Callers set z so each stacked section sits above the one tucked under it.
  panelBottom: 'rounded-b-[20px] sm:rounded-b-[28px]',
  tuckUnder: '-mt-[20px] sm:-mt-[28px]',
  // A run that tucks under a rounded-bottom section: square top, rounded bottom.
  panelEnd: 'rounded-b-[20px] sm:rounded-b-[28px] overflow-clip',
  cardGap: 'gap-4 sm:gap-5 lg:gap-6',
  eyebrow: `${TYPE.eyebrow} text-[#363535]`,
  title: `mt-4 ${TYPE.title} text-[#181a1a]`,
  lead: `mt-5 ${TYPE.body} text-[#666666] max-w-xl`,
} as const;
